module.exports = __webpack_public_path__ + "img/tournament1.226df478.png";